<template>
    <svg
        width="128"
        height="128"
        viewBox="0 0 128 128"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M57.6553 18.6105H58.3935C59.0961 18.6105 59.6676 18.039 59.6676 17.3364C59.6676 16.6339 60.2391 16.0624 60.9416 16.0624H66.6034C67.3059 16.0624 67.8775 16.6339 67.8775 17.3364C67.8775 18.039 68.449 18.6105 69.1515 18.6105H69.8838C70.5565 18.6105 71.1102 18.0925 71.1578 17.4257C71.2531 16.0922 71.3424 14.1156 69.5742 14.1156H57.8458C56.4706 14.1156 56.411 15.985 56.3813 17.3126C56.3634 18.027 56.9409 18.6105 57.6553 18.6105Z"
            class="primary-fill" />
        <path
            d="M66.0962 83.057C68.8526 81.39 70.8649 78.8955 72.127 75.5794C73.3892 72.2633 73.6035 68.8698 72.7641 65.3989L70.7994 57.2605L59.5295 55.8853L50.1289 62.2614L52.0936 70.3999C52.933 73.8767 54.6714 76.7939 57.3148 79.1693C59.9522 81.5388 62.8813 82.8367 66.0962 83.0629V83.057Z"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M55.7969 67.3458L63.1078 72.2634L76.5507 55.677"
            class="accent-stroke"
            stroke-width="7.73953"
            stroke-miterlimit="10" />
        <path
            d="M51.5059 50.8427V52.1107"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M51.5059 54.4624V55.7305"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M49.0645 53.2837H50.3325"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M52.6836 53.2837H53.9517"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M78.6465 71.4238V72.6919"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M78.6465 75.0436V76.3117"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M76.2051 73.8707H77.4732"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M79.8242 73.8707H81.0923"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M60.6426 107.841H80.1105C85.0995 107.841 89.1479 103.793 89.1479 98.804V45.1273"
            class="accent-stroke"
            stroke-width="7.73953"
            stroke-miterlimit="10" />
        <path
            d="M56.8391 107.865H48.9329C43.3664 107.865 38.8477 103.353 38.8477 97.7801V70.6976"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M69.4785 35.4885H78.76C84.3265 35.4885 88.8452 40.0013 88.8452 45.5737"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M58.0586 35.4706V17.4673"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M69.4609 35.4706V17.4673"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M39.377 100.56H43.7409C47.5749 100.56 50.6767 103.668 50.6767 107.496"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M88.161 100.56H83.7971C79.9631 100.56 76.8613 103.668 76.8613 107.496"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M48.9329 107.865C43.3664 107.865 38.8477 103.352 38.8477 97.78V46.3359C38.8477 40.6146 43.4854 35.9768 49.2067 35.9768H64.1262"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M69.4785 35.4885H78.76C84.3265 35.4885 88.8452 40.0013 88.8452 45.5737"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M39.377 100.56H43.7409C47.5749 100.56 50.6767 103.668 50.6767 107.496"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M88.161 100.56H83.7971C79.9631 100.56 76.8613 103.668 76.8613 107.496"
            class="primary-stroke"
            stroke-width="2.08372"
            stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M52.9341 113.884C54.5222 113.884 55.8097 112.597 55.8097 111.009C55.8097 109.42 54.5222 108.133 52.9341 108.133C51.346 108.133 50.0586 109.42 50.0586 111.009C50.0586 112.597 51.346 113.884 52.9341 113.884Z"
            class="primary-fill" />
        <path
            d="M74.1509 113.884C75.739 113.884 77.0265 112.597 77.0265 111.009C77.0265 109.42 75.739 108.133 74.1509 108.133C72.5628 108.133 71.2754 109.42 71.2754 111.009C71.2754 112.597 72.5628 113.884 74.1509 113.884Z"
            class="primary-fill" />
    </svg>
</template>
